exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-project-document h4[data-v-dd8c882c]{font-weight:500}.add-project-document h4 a[data-v-dd8c882c]{text-decoration:underline;color:#23a6cd}", ""]);

// exports
